import api from './api';

export const reminderService = {
  create: async (eventId, formData) => {
    const response = await api.post(`/reminders/${eventId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getByEventId: async (eventId) => {
    const response = await api.get(`/reminders/${eventId}`);
    return response.data;
  },

  getById: async (eventId, id) => {
    const response = await api.get(`/reminders/${eventId}/${id}`);
    return response.data;
  },

  update: async (eventId, id, formData) => {
    const response = await api.put(`/reminders/${eventId}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  delete: async (eventId, id) => {
    const response = await api.delete(`/reminders/${eventId}/${id}`);
    return response.data;
  }
};
